module.exports = __webpack_public_path__ + "static/img/11.5f897cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/11.jpg
// module id = 3jVy
// module chunks = 26